import React, { useReducer } from 'react';
import { CurrentUser } from '@Models/CurrentUser';
import * as Authentication from '@Services/Authentication';

type State = {
    currentUser: CurrentUser,
};

export type LoggedInAction = {
    type: string;
    user?: CurrentUser;
    stringValue?: string;
}

export enum LoggedInActionType {
    NameChanged = "NAME_CHANGED",
    NewsletterChanged = "NEWSLETTER_CHANGED",
}

const errorNoUser = 'Error: No User!';
const emptyState: State = {
    currentUser: new CurrentUser(errorNoUser, errorNoUser, errorNoUser, errorNoUser, errorNoUser, 0, 0, [], null)
}

type ContextType = State & {
    dispatch: React.Dispatch<LoggedInAction>
};

export const LoggedInContext = React.createContext<ContextType>({
    ...emptyState,
    dispatch: () => { }
});

function reducer(state: State, action: LoggedInAction) : State {
    switch (action.type) {
        case LoggedInActionType.NameChanged: {
            const newUser = state.currentUser.withNewName(action.stringValue);
            return { currentUser: newUser };
        }
        case LoggedInActionType.NewsletterChanged: {
            const newUser = state.currentUser.withNewNewsletter(parseInt(action.stringValue));
            const localUser = Authentication.getLocalStorageUser();
            if (localUser) {
                localUser.newsletter = parseInt(action.stringValue);
                Authentication.saveLocalStorageUser(localUser);
            }
            return { currentUser: newUser };        
        }    
        default:
            return state;
    }
}

// "Argument of type 'State' is not assignable to parameter of type 'never'.ts(2345)"
// this error means the reducer isn't always returning a state obvject
export function LoggedInContextProvider(props: { children: JSX.Element[] | JSX.Element, initialState?: State }) {
    const [state, dispatch] = useReducer(reducer, props.initialState || emptyState);

    const value = { ...state, dispatch };
    return <LoggedInContext.Provider value={value}>{props.children}</LoggedInContext.Provider>;
}
